import type { AiAppCenterModule } from '../types'

/** 兼容旧 app=o2o；新入口用 visitingModule（key=visiting） */
export const o2oModule: AiAppCenterModule = {
  key: 'o2o',
  label: '上门服务',
  desc: '服务预约 / 订单派发 / 评价体系',
  path: '/visiting',
  homePath: '/visiting/dashboard',
  icon: 'ep:service',
  color: '#10b981',
  hideFromMenu: true
}
